
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import styled from '@emotion/styled';
import { LiveCode } from 'shared/library/molecules/EmbedCode';
import { ILiveCode } from 'shared/library/molecules/EmbedCode/LiveCode';
import { H3 } from 'library/atoms/Typography';
export interface IExamples extends ILiveCode {
    /**
     * Title display at each section. e.g. name of the vaiant related to the component "color", "variant"
     */
    title: string;
}
interface ExampleCodeProps {
    examples: IExamples[];
}
const Examples: React.FC<ExampleCodeProps> = ({ examples }) => {
    // this needs to be here regardless if this will ever be called with `undefined` at runtime
    // as Next will complain during yarn build otherwise.
    if (!examples?.length) {
        return null;
    }
    return (<StyledExampleCode id="examples">
      {examples.map(example => {
            return (<StyledExampleSection id={example.title.replace(/\s+/g, '-').toLowerCase()} key={example.title}>
            <H3>{example.title}</H3>
            <StyledLiveCode {...example}/>
          </StyledExampleSection>);
        })}
    </StyledExampleCode>);
};
export default Examples;
const StyledExampleCode = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '& > h2': {
        width: '100%',
        textTransform: 'capitalize',
        borderBottom: theme.border,
        paddingBottom: theme.space[5]
    },
    '& > div': {
        width: '100%',
        '& + div': {
            marginTop: theme.space[8]
        }
    }
}));
const StyledExampleSection = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '& > h3': {
        width: '100%',
        textTransform: 'capitalize',
        marginBottom: theme.space[2]
    }
}));
const StyledLiveCode = styled(LiveCode)(({ theme }) => ({
    width: '100%',
    '& > div:first-of-type': {
        display: 'flex',
        padding: theme.space[5],
        background: theme.colors.white,
        border: theme.border,
        borderTopRightRadius: 6,
        borderTopLeftRadius: 6
    },
    '& > div:last-of-type': {
        position: 'relative',
        overflow: 'hidden',
        border: theme.border,
        borderTop: 0,
        borderBottomRightRadius: 6,
        borderBottomLeftRadius: 6
    }
}));

    async function __Next_Translate__getStaticProps__197303e549f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'shared/library//StyleGuide/Examples',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197303e549f__ as getStaticProps }
  